// extracted by mini-css-extract-plugin
export default {"modal":"UO-z","modalOverlay":"VO-z","outfitHeading":"WO-z"};